import { Injectable, Injector, ErrorHandler } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { NavigationService } from '../services/navigation.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private injector: Injector, private navigationService: NavigationService) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes(environment.pcrEmpiURI)) {
      // If the request is being sent to PCR EMPI, then the errors will not be handled here and the HTTP Interceptor will not show the red bar on the top of the page
      return next.handle(req);
    } else {
      // For all other HTTP requests which are not PCR, errors will be handled here
      return next.handle(req)
        .pipe(
          tap({
            error: (err: any) => {
              // Logout user if there is no valid token
              if( err.error.error == 'invalid_token' ){
                this.navigationService.appLogout();
              } 
               
              if (err instanceof HttpErrorResponse) {
                const appErrorHandler = this.injector.get(ErrorHandler);
                appErrorHandler.handleError(err);
              }
            }
          })
      );
    }
  }
}
